import React, { useState, useEffect } from "react";
import { X } from "lucide-react";

const CookieBanner: React.FC = () => {
  const [consent, setConsent] = useState<string | null>(null);
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("tsm_cookie_consent");
    setConsent(saved);
    if (saved) {
      setIsHidden(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem("tsm_cookie_consent", "all");
    // Google Consent Mode v2 signal
    if ((window as any).gtag) {
      (window as any).gtag("consent", "update", {
        analytics_storage: "granted",
      });
    }
    setConsent("all");
    setIsHidden(true);
  };

  const handleEssentialOnly = () => {
    localStorage.setItem("tsm_cookie_consent", "essential");
    // Google Consent Mode v2 signal
    if ((window as any).gtag) {
      (window as any).gtag("consent", "update", {
        analytics_storage: "denied",
      });
    }
    setConsent("essential");
    setIsHidden(true);
  };

  const handleDismiss = () => {
    setIsHidden(true);
  };

  if (isHidden || consent) {
    return null;
  }

  return (
    <aside className="tsm-cookie-banner" aria-label="Cookie consent banner">
      <div className="tsm-cookie-content">
        <div className="tsm-cookie-text">
          <p>
            We use cookies to enhance your experience, analyze traffic, and serve personalized content.
            By continuing to use this site, you consent to our{" "}
            <a href="/legal/cookies.html" target="_blank" rel="noopener noreferrer">
              Cookie Policy
            </a>
            .
          </p>
        </div>
        <div className="tsm-cookie-actions">
          <button
            type="button"
            className="tsm-cookie-button tsm-cookie-dismiss"
            aria-label="Dismiss cookie banner"
            onClick={handleDismiss}
          >
            <X size={16} aria-hidden="true" />
          </button>
          <button
            type="button"
            className="tsm-cookie-button tsm-cookie-secondary"
            onClick={handleEssentialOnly}
          >
            Essential Only
          </button>
          <button
            type="button"
            className="tsm-cookie-button tsm-cookie-primary"
            onClick={handleAcceptAll}
          >
            Accept All
          </button>
        </div>
      </div>
    </aside>
  );
};

export default CookieBanner;
